import { render, staticRenderFns } from "./CandidateReservationShowMoreBtn.vue?vue&type=template&id=472332ce&scoped=true&lang=pug&"
import script from "./CandidateReservationShowMoreBtn.vue?vue&type=script&lang=js&"
export * from "./CandidateReservationShowMoreBtn.vue?vue&type=script&lang=js&"
import style0 from "./CandidateReservationShowMoreBtn.vue?vue&type=style&index=0&id=472332ce&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "472332ce",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
